import React, { useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from 'react-router-dom';

const PayLater: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000); // 5000ms = 5 seconds

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
        <div style={{ fontSize: "4rem" }}>😄</div>
        <h1 className="text-success">Registration Successful</h1>
        <p>Thank you for registering with FTTHSA. Make sure to keep your login details so you can log in at any given time and pay.</p>
        <small>You will be redirected to the homepage shortly...</small>
        </div>
    </div>
  );
};

export default PayLater;